<template>
    <div class="container-fluid">
        <div class="row justify-content-center">
            <div class="col-12">
                <!-- Header -->
                <div class="header mt-md-5">
                    <div class="header-body">
                        <div class="row align-items-center">
                            <div class="col">
                                <h6 class="header-pretitle">{{$t('Company')}}</h6>
                                <h1 class="header-title">{{$t('Payments')}}</h1>
                            </div>
                            <div class="col-auto"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <transactions-table show-summary></transactions-table>
    </div>
</template>

<script>

import Money from '@/components/Money.vue';
import InvoiceModal from '@/Pages/Sales/InvoiceModal.vue';
import { modalMixins } from '@/mixins/modal.js'
import DateFilter from '@/components/DateFilter.vue';
import StatusBadge from '@/components/StatusBadge.vue';
import TeamFilter from "@/components/TeamFilter";
import User from '@/components/User.vue'
import Transactions from "../../People/Customer/Transactions";
import TransactionsTable from "@/components/TransactionsTable";

export default {
    mixins: [modalMixins],
    components: {
        TransactionsTable,
        Transactions,
        User,
        Money,
        DateFilter,
        StatusBadge,
        InvoiceModal,
        TeamFilter
    },
    data() {
        return {};
        // asfsad
    },
    computed: {},
    watch: {},
    mounted() {
    },
    methods: {
    }
}
</script>
